import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const KebabIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="3" viewBox="0 0 19 3" fill="none">
    <circle cx="17.5" cy="1.5" r="1.5" transform="rotate(90 17.5 1.5)" fill="currentColor" />
    <circle cx="9.5" cy="1.5" r="1.5" transform="rotate(90 9.5 1.5)" fill="currentColor" />
    <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(90 1.5 1.5)" fill="currentColor" />
  </svg>,
  'kebab'
);
